import { T, useGT } from 'gt-react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

/**
 * The Name + Description fields every "stage a new review" dialog asks for.
 * `idPrefix` keeps the label/input ids unique per dialog.
 */
export function ChangeSetNameFields({
  idPrefix,
  name,
  onNameChange,
  description,
  onDescriptionChange,
  disabled,
}: {
  idPrefix: string;
  name: string;
  onNameChange: (name: string) => void;
  description: string;
  onDescriptionChange: (description: string) => void;
  disabled: boolean;
}) {
  const gt = useGT();
  return (
    <>
      <div className="flex flex-col gap-1.5">
        <Label htmlFor={`${idPrefix}-name`}>
          <T context="label for the change set name field">Name</T>
        </Label>
        <Input
          id={`${idPrefix}-name`}
          autoFocus
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          placeholder={gt('e.g. Q3 price update', {
            context: 'placeholder for the change set name field',
          })}
          disabled={disabled}
          maxLength={255}
        />
      </div>

      <div className="flex flex-col gap-1.5">
        <Label htmlFor={`${idPrefix}-description`}>
          <T context="label for the change set description field">
            Description
          </T>
        </Label>
        <Textarea
          id={`${idPrefix}-description`}
          value={description}
          onChange={(e) => onDescriptionChange(e.target.value)}
          placeholder={gt('Optional notes about this change set', {
            context: 'placeholder for the change set description field',
          })}
          disabled={disabled}
          rows={3}
          maxLength={2000}
        />
      </div>
    </>
  );
}
